export default __webpack_public_path__ + "static/media/burger-sizzle.38b87d14.mp3";